// extracted by mini-css-extract-plugin
export default {"hideTooltip":"J_-z","fadeIn":"K_-z","delay":"L_-z","recommendedSizeTooltip":"M_-z"};